import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { formatIQD } from "../lib/format";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { CheckCircle2, XCircle, Search } from "lucide-react";

export default function ReminderLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all");

  useEffect(() => { api.get("/reminders/logs").then((r) => setRows(r.data)); }, []);

  const filtered = rows.filter((r) => {
    if (status === "sent" && !r.ok) return false;
    if (status === "skipped" && r.ok) return false;
    if (q && !(r.name || "").toLowerCase().includes(q.toLowerCase()) && !(r.phone || "").includes(q)) return false;
    return true;
  });

  const stats = {
    total: rows.length,
    sent: rows.filter((r) => r.ok).length,
    skipped: rows.filter((r) => !r.ok).length,
  };

  return (
    <div className="space-y-6" data-testid="reminder-log-page">
      <div>
        <h1 className="heading text-2xl font-extrabold tracking-tight">Reminder Log</h1>
        <p className="text-sm text-muted-foreground">Every WhatsApp reminder attempt — who, when, and whether it delivered.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Card className="p-4"><div className="text-xs uppercase text-muted-foreground">Total Attempts</div><div className="heading text-2xl font-extrabold">{stats.total}</div></Card>
        <Card className="p-4"><div className="text-xs uppercase text-muted-foreground">Delivered</div><div className="heading text-2xl font-extrabold text-emerald-700">{stats.sent}</div></Card>
        <Card className="p-4"><div className="text-xs uppercase text-muted-foreground">Skipped / Failed</div><div className="heading text-2xl font-extrabold text-rose-700">{stats.skipped}</div></Card>
      </div>
      <Card className="p-4">
        <div className="flex gap-3 flex-wrap">
          <div className="relative flex-1 min-w-56">
            <Search size={14} className="absolute left-2.5 top-2.5 text-muted-foreground" />
            <Input placeholder="Search name or phone" value={q} onChange={(e) => setQ(e.target.value)} className="pl-8" data-testid="rl-search" />
          </div>
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger className="w-48" data-testid="rl-status"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              <SelectItem value="sent">Delivered</SelectItem>
              <SelectItem value="skipped">Skipped / Failed</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </Card>
      <Card className="p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/50">
              <tr className="text-left text-xs uppercase text-muted-foreground">
                <th className="p-3">When</th><th className="p-3">Employee</th><th className="p-3">Phone</th>
                <th className="p-3 text-right">Outstanding</th>
                <th className="p-3">Result</th><th className="p-3">Details</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id} className="border-t table-row-hover" data-testid={`rl-row-${r.id}`}>
                  <td className="p-3 mono text-xs">{r.sent_at ? new Date(r.sent_at).toLocaleString() : "—"}</td>
                  <td className="p-3 font-medium">{r.name}</td>
                  <td className="p-3 mono text-muted-foreground">{r.phone || "—"}</td>
                  <td className="p-3 text-right mono">{formatIQD(r.outstanding)}</td>
                  <td className="p-3">
                    {r.ok ? (
                      <span className="inline-flex items-center gap-1 text-emerald-700 text-xs font-medium"><CheckCircle2 size={14} />Delivered</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-rose-700 text-xs font-medium"><XCircle size={14} />{r.error?.includes("Excluded") ? "Excluded" : "Failed"}</span>
                    )}
                  </td>
                  <td className="p-3 text-xs text-muted-foreground">{r.ok ? (r.sid || "") : (r.error || "—")}</td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-muted-foreground">No reminder logs yet. Try the "Send WhatsApp Reminders" button on the Outstanding page.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
